var React = require('react');
var PropTypes = React.PropTypes;
import Helpers from '../../../utils/helpers';

var PartDescription = React.createClass({
  getInitialState: function() {
    return {
      content: this.props.content || {},
      contentIndex: this.props.contentIndex || 0,
      score: this.props.score || 1,
      numPoints: this.props.numPoint || 1
    };
  },

  componentWillReceiveProps: function(nextProps) {
    this.setState({
      content: nextProps.content ? nextProps.content : this.state.content,
      contentIndex: nextProps.contentIndex ? nextProps.contentIndex : this.state.contentIndex,
      numPoints: nextProps.numPoints ? nextProps.numPoints : this.state.numPoints,
      score: nextProps.score ? nextProps.score : this.state.score
    })
  },

  render: function() {
    console.log(this.state.content)
    var content = this.state.content,
        contentIndex = this.state.contentIndex,
        score = this.state.score,
        numPoints = this.state.numPoints;
    var partScore = content.partScore ? content.partScore : content.answerValue;
    partScore = partScore * numPoints / score
    return (
      <div className="part-content">
        {
          content.type === 'AUTO_MARKING' &&
          <h4>{"Part " + (contentIndex+1) + " - " + partScore + (partScore > 1 ? " marks" : " mark")} - This part should be reviewed </h4>
        }
        {
           content.type === 'MANUAL_MARKING' &&
           <h4>{"Part " + (contentIndex+1) + " - " + partScore + (partScore > 1 ? " marks" : " mark")} - <span style={{color: "red"}}>This part needs marking</span> </h4>
        }
        <div dangerouslySetInnerHTML={{__html: content.description || 'This part has no content'}}></div>
        <ul className="text-input-list">
            <li>
              {(content.type === 'AUTO_MARKING' && content.text &&<h4>Answer</h4>)}
            </li>  
            <li>
              {
                (content.type === 'AUTO_MARKING' && content.preText &&
                  <div className="cell">
                    <input className="form-control" disabled type="text" defaultValue={content.preText}/>
                  </div>
                )
              }
              {
                (content.type === 'AUTO_MARKING' && content.text &&
                  <div className="cell" style={{'minWidth': "50%"}}>
                    {/* <input className="form-control" disabled type="text" defaultValue={_this.state.kquestion.textInputAnswers[0].text}/> */}
                    <span dangerouslySetInnerHTML={{__html: Helpers.convertToHtml(content.text)}}></span>
                  </div>
                )
              }
              {
                (content.type === 'AUTO_MARKING' && content.postText &&
                  <div className="cell">
                    <input className="form-control" disabled type="text" defaultValue={content.postText}/>
                  </div>
                )
              }
            </li>
        </ul>
      </div>
    );
  }

});

module.exports = PartDescription;



/** WEBPACK FOOTER **
 ** ./src/components/QuestionContent/LongQuestionFraction/PartDescription.js
 **/